<template>
    <div>
        <section class="hero">
            <div class="hero__left">
                <div class="hero__container">
                    <div class="hero__body">
                        <div class="hero__info">
                            <h2 class="title title--m title--uppercase hero__title hero__title--w682" v-html="$lang('placeLanding.title')">
                            </h2>
                            <div class="hero__text hero__text--w622" v-html="$lang('placeLanding.text')"></div>
                            <div class="hero__links">
                                <!--Для задачи по расчету стоимости памятного места
                                <a :href="locale === 'ru' ? $router.resolve({ name: 'place-cost'}).href : '#send-request'"
                                   class="btn btn&#45;&#45;big btn&#45;&#45;main-bg hero__link hero__create"
                                   @mouseover="moved = true"
                                   @mouseleave="moved = false"
                                >
                                    {{ $lang('placeLanding.createPage') }}
                                </a>
                                -->

                                <a href="#send-request"
                                   class="btn btn--big btn--main-bg hero__link hero__create"
                                   @mouseover="moved = true"
                                   @mouseleave="moved = false"
                                >
                                    {{ $lang('placeLanding.createPage') }}
                                </a>

                                <a v-if="locale === 'ru'"
                                   href="#examples"
                                   class="link hero__link hero__examples"
                                >
                                    <span>{{ $lang('placeLanding.pageExample') }}</span>
                                </a>
                            </div>
                        </div>
                        <div class="hero__imgs hero__imgs--memorial">
                            <img src="/assets/front/img/hero-pame-1.png" alt="img" class="hero__img shadow__img hero__img--one">
                            <img src="/assets/front/img/hero-pame-2.png" alt="img" class="hero__img shadow__img hero__img--two">
                        </div>
                    </div>
                </div>
            </div>
            <div class="hero__right">
                <img class="hero__right-bg" src="/assets/front/img/hero-bg-pame.png" alt="img"
                     :class="{'hero__right-bg--move' : moved}"/>
            </div>
        </section>

        <section class="benefit" id="benefit">
            <div class="container">
                <h2 class="title title--uppercase title--ms benefit__title">{{ $lang('placeLanding.benefit') }}</h2>
                <swiper class="swiper-container benefit__who" :options="swiperOption">
                    <swiper-slide class="benefit__who-item" :class="{'benefit__who-item--active': benefitActive === 1}">
                        <div class="benefit__who-item__inner"
                            @click="selectBenefit(1)">
                            <div class="benefit__who-item__icon">
                                <svg class="">
                                    <use xlink:href="/assets/front/img/sprite.svg#icon-benefit-1"></use>
                                </svg>
                            </div>

                            <div class="title benefit__who-item__title" v-html="$lang('placeLanding.city')"></div>
                        </div>
                    </swiper-slide>

                    <swiper-slide class="benefit__who-item" :class="{'benefit__who-item--active': benefitActive === 2}">
                        <div class="benefit__who-item__inner"
                            @click="selectBenefit(2)">
                            <div class="benefit__who-item__icon">
                                <svg class="">
                                    <use xlink:href="/assets/front/img/sprite.svg#icon-benefit-2"></use>
                                </svg>
                            </div>

                            <div class="title benefit__who-item__title" v-html="$lang('placeLanding.company')"></div>
                        </div>
                    </swiper-slide>

                    <swiper-slide class="benefit__who-item" :class="{'benefit__who-item--active': benefitActive === 3}">
                        <div class="benefit__who-item__inner"
                            @click="selectBenefit(3)">
                            <div class="benefit__who-item__icon">
                                <svg class="">
                                    <use xlink:href="/assets/front/img/sprite.svg#icon-benefit-3"></use>
                                </svg>
                            </div>

                            <div class="title benefit__who-item__title" v-html="$lang('placeLanding.tour')"></div>
                        </div>
                    </swiper-slide>
                </swiper>

                <div class="benefit__tags">
                    <div class="benefit__tag"
                         :class="{'benefit__tag--active': benefitActive === 1}">{{ $lang('placeLanding.tag_1') }}</div>

                    <div class="benefit__tag"
                         :class="{' benefit__tag--active': benefitActive === 1}">{{ $lang('placeLanding.tag_2') }}</div>

                    <div class="benefit__tag benefit__tag--active">{{ $lang('placeLanding.tag_3') }}</div>

                    <div class="benefit__tag"
                         :class="{'benefit__tag--active': benefitActive === 1}">{{ $lang('placeLanding.tag_4') }}</div>

                    <div class="benefit__tag"
                         :class="{'benefit__tag--active': benefitActive === 3}">{{ $lang('placeLanding.tag_5') }}</div>

                    <div class="benefit__tag"
                         :class="{'benefit__tag--active': benefitActive === 2}">{{ $lang('placeLanding.tag_6') }}</div>

                    <div class="benefit__tag"
                         :class="{'benefit__tag--active': benefitActive === 2}">{{ $lang('placeLanding.tag_7') }}</div>

                    <div class="benefit__tag"
                         :class="{'benefit__tag--active': benefitActive === 2}">{{ $lang('placeLanding.tag_8') }}</div>
                </div>
            </div>
        </section>

        <div id="examples" v-if="locale === 'ru'">
            <section class="f-page__example" v-if="memorial">
                <div class="container">
                    <h2 class="title title--uppercase title--ms f-page__example-title">{{ $lang('placeLanding.memorialTitle') }}</h2>
                    <div class="f-page__example-item shadow">
                        <div class="f-page__example-change f-page__example-change--static">
                            <button class="btn btn--main-bg f-page__example-change__btn" @click="loadRandomMemorial">
                                <svg width="24" height="24">
                                    <use xlink:href="/assets/front/img/sprite.svg#icon-refresh"></use>
                                </svg>
                            </button>
                            <span v-html="$lang('placeLanding.memorialExample')"></span>
                        </div>
                        <div class="memorial__example">
                            <h3 class="title title--uppercase memorial__example-title">{{ memorial.title }}</h3>
                            <div class="memorial__example-content">
                                <div v-if="memorial.photos[0].custom_properties.tabName === 'one'" class="memorial__gallery memorial__gallery--example memorial__gallery--bg memorial__gallery--one">
                                    <div class="memorial__gallery-item memorial__gallery-item--one">
                                        <img :src="memorial.photos[0].url" alt="img" class="memorial__gallery-item__img">
                                    </div>
                                </div>

                                <div v-else-if="memorial.photos[0].custom_properties.tabName === 'two'" class="memorial__gallery memorial__gallery--example memorial__gallery--bg memorial__gallery--two">
                                    <div class="memorial__gallery-item memorial__gallery-item--two-big">
                                        <img :src="memorial.photos[0].url" alt="img" class="memorial__gallery-item__img">
                                    </div>
                                    <div class="memorial__gallery-item memorial__gallery-item--two-small">
                                        <img :src="memorial.photos[1].url" alt="img" class="memorial__gallery-item__img">
                                    </div>
                                </div>

                                <div v-else-if="memorial.photos[0].custom_properties.tabName === 'three'" class="memorial__gallery memorial__gallery--example memorial__gallery--bg memorial__gallery--three">
                                    <div class="memorial__gallery-item memorial__gallery-item--three-big">
                                        <img :src="memorial.photos[0].url" alt="img" class="memorial__gallery-item__img">
                                    </div>
                                    <div class="memorial__gallery-item memorial__gallery-item--three-small">
                                        <img :src="memorial.photos[1].url" alt="img" class="memorial__gallery-item__img">
                                    </div>
                                    <div class="memorial__gallery-item memorial__gallery-item--three-small">
                                        <img :src="memorial.photos[2].url" alt="img" class="memorial__gallery-item__img">
                                    </div>
                                </div>

                                <div class="memorial__example-info">
                                    <div class="title title--uppercase memorial__example-info__title">{{ memorial.subtitle }}</div>
                                    <div class="title title--s memorial__example-dates">{{ memorial.build_at }}</div>
                                    <img alt="pepper" src="../../../svg-icons/scroll.svg" style="width: 31px; height: 31px">
                                    <p class="memorial__example-desc" v-html="memorial.short_description"></p>
                                    <a :href="domain + '/place/' + memorial.slug"  target="_blank" class="btn btn--big btn--main-bg f-page__example-link">
                                        {{ $lang('placeLanding.memorialWatch') }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <section class="why" id="why">
            <div class="container why__container">
                <h2 class="title title--uppercase title--ms why__title">{{ $lang('placeLanding.as') }}</h2>
                <div class="why__content">
                    <div class="why__item" v-for="item in whyItems">
                        <svg class="why__item-icon">
                            <use :xlink:href="'/assets/front/img/sprite.svg#' + item.icon"></use>
                        </svg>
                        <div class="why__item-text">
                            <span class="why__item-name">{{ item.name }}</span>
                            <span class="why__item-desc">{{ item.desc }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section id="send-request" class="cta-banner">
            <div class="container cta-banner__container">
                <div class="cta-banner__block">
                    <h2 class="title title--uppercase title--center title--white title--sm cta-banner__title">
                        {{ $lang('placeLanding.createMemorial') }}
                    </h2>

                    <!--Для задачи по расчету стоимости памятного места
                    <a v-if="locale === 'ru'" :href="$router.resolve({ name: 'place-cost'}).href"
                       class="btn btn--big btn--white-bg cta-banner__btn">
                        {{ $lang('placeLanding.cost') }}
                    </a>
                    -->

                    <router-link :to="{ name: 'place-feedback', params: {title: $lang('placeLanding.feedback.title')}}"
                                 class="btn btn--big btn--white cta-banner__btn">
                        {{ $lang('placeLanding.send') }}
                    </router-link>

                    <img src="/assets/front/img/cta-banner.png" alt="img" class="info__bg cta-banner__bg">
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import ApiService from "../../api/api";
import Vue from "vue";
import {mapMutations, mapState} from "vuex";

export default {
    name: 'PlaceLanding',
    data() {
        return {
            domain: window.laravel.appUrlByLocale,
            locale: window.laravel.locale,
            swiperOption: {
                slidesPerView: 'auto',
                spaceBetween: 16,
                breakpoints: {
                    1200: {
                        spaceBetween: 62,
                    }
                }
            },
            memorial: null,
            benefitActive: 1,
            moved: false,
            whyItems: [
                {
                    icon: 'icon-w-cart',
                    name: Vue.prototype.$lang('placeLanding.forever_1'),
                    desc: Vue.prototype.$lang('placeLanding.forever_2'),
                },
                {
                    icon: 'icon-w-cloud',
                    name: Vue.prototype.$lang('placeLanding.saveForever_1'),
                    desc: Vue.prototype.$lang('placeLanding.saveForever_2'),
                },
                {
                    icon: 'icon-w-safe',
                    name: Vue.prototype.$lang('placeLanding.protect_1'),
                    desc: Vue.prototype.$lang('placeLanding.protect_2'),
                },
                {
                    icon: 'icon-w-ez',
                    name: Vue.prototype.$lang('placeLanding.just_1'),
                    desc: Vue.prototype.$lang('placeLanding.just_2'),
                },
                {
                    icon: 'icon-w-content',
                    name: Vue.prototype.$lang('placeLanding.yourself_1'),
                    desc: Vue.prototype.$lang('placeLanding.yourself_2'),
                },
                {
                    icon: 'icon-w-qr',
                    name: Vue.prototype.$lang('placeLanding.selfQr_1'),
                    desc: Vue.prototype.$lang('placeLanding.selfQr_2'),
                },
                {
                    icon: 'icon-w-pay',
                    name: Vue.prototype.$lang('placeLanding.noCash_1'),
                    desc: Vue.prototype.$lang('placeLanding.noCash_2'),
                },
                {
                    icon: 'icon-w-refresh',
                    name: Vue.prototype.$lang('placeLanding.update_1'),
                    desc: Vue.prototype.$lang('placeLanding.update_2'),
                },
                {
                    icon: 'icon-w-percent',
                    name: Vue.prototype.$lang('placeLanding.percent_1'),
                    desc: Vue.prototype.$lang('placeLanding.percent_2'),
                },
            ]
        }
    },
    mounted() {
        /*Примеры памятных мест отображаем только для русской локализации*/
        if (this.locale !== 'ru') {
            return;
        }

        this.loadRandomMemorial();
    },
    computed: {
        ...mapState('header', [
           'headerPages'
        ])
    },
    methods: {
        ...mapMutations('header', [
            'setHeaderPages'
        ]),
        loadRandomMemorial() {
            let previousId = this.memorial ? this.memorial.id : null;

            ApiService.get('/memorial/random', {previousId: previousId}).then((response) => {
                this.memorial = response.data;
            });
        },
        selectBenefit(num) {
            this.benefitActive = num;
        },
    }
}
</script>
